module.exports = __webpack_public_path__ + "img/gsndc2762_1.1dceca42.svg";